import React, { useState, useEffect } from 'react'
import CloseIcon from '@material-ui/icons/Close'
import Modal from '@material-ui/core/Modal'

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  ReferenceLine,
} from 'recharts'

import styles from './charts.module.css'

function BarCharts(props) {
  const dataFormater = (number) => {
    const numberFormat = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
    return numberFormat.format(number)
  }

  const axisFormater = (number) => {
    return Math.round(number)
  }

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div
          style={{
            display: 'flex',
            width: 'fit-content',
            height: 'fit-content',
            background: ' #ffffff',
            borderRadius: '4px',
            padding: '10px 5px',
            border: '1px solid #d4d4d4',
          }}
        >
          <p
            style={{
              width: 'fit-content',
              height: 'fit-content',
              alignSelf: 'center',
              margin: 'auto',
              fontSize: '12px',
              fontWeight: '700',
              color: `${payload[0].color}`,
            }}
          >{`${payload[0].name}:`}</p>
          <p
            style={{
              width: 'fit-content',
              height: 'fit-content',
              alignSelf: 'center',
              margin: 'auto',
              fontSize: '12px',
              fontWeight: '600',
              color: '#464646',
            }}
          >
            &nbsp;{payload[0].value}&nbsp;USD/MWH
          </p>
        </div>
      )
    }

    return null
  }
  // console.log(ReferenceLine)

  return (
    <Modal open={props.chartModal} onClose={() => props.setChartModal(false)}>
      <div className={styles.modalBody}>
        <div className={styles.modalTitleContainer}>
          <h2 className={styles.modalTitle}>
            Average LMP - {props.chartData.name} {props.chartData.voltage}kV
          </h2>
          <CloseIcon className={styles.closeIcon} onClick={() => props.setChartModal(false)} />
        </div>
        {props.chartData !== undefined ? (
          <div className={styles.chartContainer}>
            <label className={styles.chartLbl}>USD/MWh</label>
            <ResponsiveContainer>
              <BarChart
                //   width={500}
                //   height={300}
                data={props.chartData.data}
                margin={{
                  top: 5,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" vertical={false} horizontal={false} />
                <XAxis dataKey="date" />
                <YAxis type="number" tickFormatter={axisFormater} />
                <Tooltip content={<CustomTooltip />} />
                {props.showLegend ? <Legend /> : null}
                {props.chartData.barKeys.map((key) => (
                  <Bar name={key.name} dataKey={key.dataKey} fill={key.fill} />
                ))}
                <ReferenceLine
                  y={props.chartData.lmp_avg}
                  label={{ position: 'top', value: 'Avg ' + props.chartData.lmp_avg + ' USD/MWH', fontSize: 14 }}
                  stroke="gray"
                  strokeDasharray="3 3"
                />
              </BarChart>
            </ResponsiveContainer>
          </div>
        ) : null}
      </div>
    </Modal>
  )
}

BarCharts.defaultProps = {
  chartData: {
    type: 'bar',
    name: 'SBN Test',
    voltage: '400',
    lmp_avg: '20',
    barKeys: [{ dataKey: 'lmp', fill: '#22d1e0', name: 'LMP' }],
    data: [
      {
        date: '01/22',
        lmp: 2400,
      },
      {
        date: '02/22',
        lmp: 1398,
      },
      {
        date: '03/22',
        lmp: 9800,
      },
      {
        date: '04/22',
        lmp: 3908,
      },
      {
        date: '05/22',
        lmp: 4800,
      },
      {
        date: '06/22',
        lmp: 3800,
      },
      {
        date: '07/22',
        lmp: 4300,
      },
      {
        date: '08/22',
        lmp: 2400,
      },
      {
        date: '09/22',
        lmp: 1398,
      },
      {
        date: '10/22',
        lmp: 9800,
      },
      {
        date: '11/22',
        lmp: 3908,
      },
      {
        date: '12/22',
        lmp: 4800,
      },
    ],
  },
  showLegend: true,
}

export default BarCharts
